import { Loader2 } from "lucide-react";

export const FullPageLoader = ({ label = "Loading…" }) => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="full-page-loader">
    <div className="flex items-center gap-3 text-slate-600">
      <Loader2 className="h-5 w-5 animate-spin text-[#0078D4]" />
      <span className="text-sm">{label}</span>
    </div>
  </div>
);

export const InlineLoader = () => (
  <div className="py-24 flex justify-center" data-testid="inline-loader">
    <Loader2 className="h-6 w-6 animate-spin text-[#0078D4]" />
  </div>
);

const Bone = ({ className }) => <div className={`animate-pulse rounded-2xl bg-slate-200/70 ${className}`} />;

export const PageSkeleton = ({ full = false }) => (
  <div className={`space-y-6 ${full ? "max-w-5xl mx-auto px-4 py-12 min-h-screen" : ""}`} data-testid="page-skeleton" aria-busy="true">
    <Bone className="h-8 w-2/3 max-w-sm" />
    <Bone className="h-4 w-1/2 max-w-xs" />
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <Bone className="h-36" /><Bone className="h-36" /><Bone className="h-36 hidden lg:block" />
    </div>
    <Bone className="h-64" />
  </div>
);

export const ChartSkeleton = ({ height = 360 }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-6 space-y-4" style={{ minHeight: height }} data-testid="chart-skeleton" aria-busy="true">
    <Bone className="h-5 w-1/3" />
    <Bone className="h-3 w-1/2" />
    <Bone className="h-48" />
  </div>
);
